<template>
  <div class="video-container" ref="test">
    <el-button icon="upload" size="mini" type="success" @click="handlerClickUpload" class="title_button2">上传视频</el-button>
    <input type="file" :id="'des_video' + id" accept="video/*" name="des_video" style="display: none;" @change="handlerVideoChange"/>
    <!-- <el-input type="file" id="des_video" accept="video/*" name="des_video" style="display: none;" @change="handlerVideoChange"></el-input> -->
    <el-dialog title="视频上传中..."
      :visible.sync="dialogUploading.show"
      :close-on-click-modal="dialogUploading.clickClose"
      :close-on-press-escape="dialogUploading.escClose"
      :show-close="dialogUploading.showClose"
      :before-close="handlerBeforeClose">
      <div class="textAlign">
        <el-progress :percentage="progress" :status="status" type="circle"></el-progress>
      </div>
    </el-dialog>
    <el-dialog title="视频上传完毕"
      width="37%"
      :visible.sync="dialogUploaded.show"
      :before-close="handleClose"
      :close-on-click-modal="dialogUploaded.clickClose"
      :close-on-press-escape="dialogUploaded.escClose">
      <div class="video-wrapper">
        <video height="auto" :id="'video' + id" controls="controls" style="object-fit: fill" preload="none" webkit-playsinline="true" x-webkit-airplay="true" playsinline="true" x5-video-orientation="h5" x5-video-player-fullscreen="true" :src="video.url" :poster="video.posterUrl"></video>
        <div>视频正在处理中, 请保存, 稍后方可观看</div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button @click="handlerSubmit" type="success">确认视频</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'w-video',
  data () {
    return {
      progress: 0,
      status: '',
      dialogUploading: {
        show: false,
        clickClose: false,
        escClose: false,
        showClose: false
      },
      dialogUploaded: {
        show: false,
        clickClose: false,
        escClose: false
      },
      video: {
        url: '',
        posterUrl: '',
        videoUrl: ''
      },
      id: Math.ceil(Math.random() * 1000)
    }
  },
  methods: {
    handlerBeforeClose () {},
    handlerClickUpload () {
      this.dialogUploading.show = false
      this.dialogUploaded.show = false
      let inputId = 'des_video' + this.id
      document.getElementById(inputId).click()
    },
    handlerVideoChange (e) {
      let files = e.currentTarget.files
      if (files.length === 0) { return }
      let file = files[0]
      let inputId = 'des_video' + this.id
      document.getElementById(inputId).value = ''
      this.progress = 0
      let checkResult = this.handlerCheck(file) // 文件大小校验
      if (!checkResult) { return }
      this.dialogUploading.show = true
      this.handlerPostFile(file, 0) // 分片上传
    },
    handlerCheck (file) {
      let size = file.size
      if (size > 100 * 1024 * 1024) {
        this.handlerOpenErrorMsg()
        return false
      }
      return true
    },
    handlerOpenErrorMsg () {
      this.$alert('很抱歉T.T, 上传视频的请少于100M', '文件过大', {
        confirmButtonText: '确定',
        callback: action => {
          this.$message({ message: '请上传少于100M的视频T_T', type: 'warning' })
        }
      })
    },
    handlerPostFile (file, i, name) {
      const _this = this
      let size = file.size // 总大小
      let shardSize = 1 * 1024 * 1024 // 以1MB为一个分片
      let shardCount = Math.ceil(size / shardSize) // 总片数
      if (i >= shardCount) { return }
      // 计算每一片的起始与结束为止
      let start = i * shardSize
      let end = Math.min(size, start + shardSize)
      // 创建xhr
      let xhr = new XMLHttpRequest()
      let url = 'http://resource.huaxuezoo.com/video/upload'
      // formData对象
      let fd = new FormData()
      fd.append('file', file.slice(start, end))
      fd.append('chunks', shardCount)
      fd.append('chunk', i)
      if (name && name.length > 0) {
        fd.append('fileId', name)
      }
      xhr.upload.onprogress = function (evt) {
        if (evt.lengthComputable) {
          let percentComplete = Math.ceil(evt.loaded / evt.total / shardCount * 100) + Math.floor(i * 100 / shardCount)
          _this.progress = percentComplete
        }
      }
      xhr.open('POST', url, true)
      xhr.onreadystatechange = function () {
        if (xhr.readyState === 4 && xhr.status === 200) {
          let result = JSON.parse(xhr.responseText)
          if (result.error !== null && result.error === 1) {
            _this.handlerOpenErrorMsg()
            return
          }
          i++
          _this.handlerPostFile(file, i, result[0]['id'])
          if (i === shardCount) {
            _this.handlerUploaded(result)
          }
        } else if (xhr.status !== 200) {
          _this.dialogUploading.show = false
          _this.dialogUploaded.show = false
          _this.$alert('网络原因, 上传视频出错了╮(╯▽╰)╭', '出错了!', {
            confirmButtonText: '确定'
          })
        }
      }
      xhr.send(fd)
    },
    handlerUploaded (e) {
      this.status = ''
      this.dialogUploading.show = false
      this.video.url = 'http://resource.huaxuezoo.com/video/' + e[0]['id']
      this.video.posterUrl = e[1]['url']
      this.video.videoUrl = e[0]['url']
      this.dialogUploaded.show = true
    },
    handlerSubmit () {
      this.$emit('callback', this.video)
      this.dialogUploaded.show = false
    },
    handleClose () {
      let videoId = 'video' + this.id
      document.getElementById(videoId).pause()
      this.dialogUploaded.show = false
      this.video.url = ''
      this.video.posterUrl = ''
      this.video.videoUrl = ''
    }
  },
  created () {}
}
</script>

<style>
  .video-wrapper {
    width: 100%;
    text-align: center;
  }
  .video-container video {
    max-width: 80%;
    max-height: 500px;
  }
</style>



// WEBPACK FOOTER //
// src/components/base/video.vue